export const INPUT_LAYOUT = {
  stacked: 'stacked',
  inline: 'inline',
};
